const HEADERS = [
  '日付',
  '配信数',
  'サイト訪問数',
  '配信カバー率',
];

const FIELDS = [
  'start_at',
  'all_campaign.session_count',
  'all_access.session_count',
  'session_cover_rate',
];

const FORMAT = 'YYYYMM';

angular.module('zc')
  .component('zcSiteReportSessionCover', {
    templateUrl: '/templates/projects.site_reports/session_cover.html',
    bindings: { project: '<' },
    controller: zcSiteReportSessionCover,
  });

zcSiteReportSessionCover.$inject = ['$scope', '$window', 'Apollo', 'ChartV2', 'lineChartV2Config'];
function zcSiteReportSessionCover($scope, $window, Apollo, ChartV2, lineChartV2Config) {
  const vm = this;

  $scope.$watch('$ctrl.project', project => {
    if(!project || !project.dailyStats) return;
    vm.filename = getFilename();
    vm.getCSV = getCSV;
    setChartConfig();
  });

  function getFilename() {
    const yearMonth = moment(vm.project.thisMonthStat.start_at).format(FORMAT);
    return `session-cover-${vm.project.apikey}-${yearMonth}.csv`;
  }

  function getCSV() {
    if(!vm.project.dailyStats) return;
    const result = [];
    result.push(HEADERS);
    vm.project.dailyStats.forEach(stat => {
      const row = FIELDS.map(field => _.get(stat, field));
      result.push(row);
    });
    return result;
  }

  function setChartConfig() {
    const allAccesses = [];
    const allCampaigns = [];
    vm.project.dailyStats.forEach(stat => {
      if(!stat.session_cover_rate) return;
      const startAt = moment(stat.start_at).valueOf();
      allAccesses.push([startAt, stat.all_access.session_count]);
      allCampaigns.push([startAt, stat.session_cover_rate * 100]);
    });
    const chart = new ChartV2(lineChartV2Config, {
      yAxis: [{
        title: { text: null },
        min: 0,
        labels: { formatter: function() { return `${$window.Highcharts.numberFormat(this.value, 0)} セッション` } },
      }, {
        opposite: true,
        title: { text: null },
        min: 0,
        labels: { formatter: function() { return `${$window.Highcharts.numberFormat(this.value, 2)} %` } },
      }]
    });
    vm.chartConfig = chart.getConfig();
    chart.addSeries({
      type: 'column',
      name: '配信数',
      data: allAccesses,
      tooltip: {
        valueSuffix: 'セッション',
        valueDecimals: 0
      },
      yAxis: 0
    });
    chart.addSeries({
      type: 'line',
      name: '配信カバー率',
      data: allCampaigns,
      tooltip: {
        valueSuffix: '%',
        valueDecimals: 1
      },
      yAxis: 1
    });
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.site_reports/session_cover.controller.js